"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersSubmitSelectHeader = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_element_1 = require("client/components/kpi-header/kpi-element");
const kpi_element_group_1 = require("client/components/kpi-header/kpi-element-group");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const paper_1 = require("client/components/material/paper");
const modal_1 = require("client/components/modal");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/orders/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
const alert_1 = require("../../../../components/ui/alert");
require("./orders-submit-select-header.less");
const greenElement = {
    color: kpi_element_1.KPIElementColor.Green,
    label: "Ready to Transmit",
    size: kpi_element_1.KPIElementSize.Small,
    value: 0
};
const redElement = {
    color: kpi_element_1.KPIElementColor.Red,
    label: "Action Required",
    size: kpi_element_1.KPIElementSize.Large,
    value: 0
};
const yellowElement = {
    color: kpi_element_1.KPIElementColor.Yellow,
    label: "Already Submitted",
    size: kpi_element_1.KPIElementSize.Small,
    value: 0
};
const core_1 = require("@material-ui/core");
const router_1 = require("client/components/router");
let OrdersSubmitSelectHeader = class OrdersSubmitSelectHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.parsedRows = [];
        this.parsedRowsTruncated = [];
        this.rowSelected = false;
        this.selectedRowIndex = null;
        this.noHeaderRowSelectOnConfirm = false;
        this.inquireAutomation = false;
        this.orderColumnsHeader = [];
        this.fileFormat = null;
        this.getImportedRowsObject = () => {
            const headers = this.parsedRowsTruncated.slice(0, 1)[0]
                ? this.parsedRowsTruncated
                    .slice(0, 1)[0]
                    .map((header) => header.trim())
                : this.parsedRowsTruncated.slice(0, 1)[0];
            const rows = this.parsedRowsTruncated.slice(1);
            const importedData = rows.map(row => {
                const order = {};
                row.forEach((value, index) => {
                    order[headers[index]] = value;
                });
                return order;
            });
            return importedData;
        };
        this.handleOnConfirmation = () => {
            if (!this.rowSelected) {
                // logic to pop modal to tell user to select a header row.
                this.noHeaderRowSelectOnConfirm = true;
            }
            else {
                store_1.ordersStore.importColumnsHeader = this.parsedRows[this.selectedRowIndex || 0];
            }
            this.parsedRowsTruncated = this.parsedRows.slice(this.selectedRowIndex);
            const sampleDataRows = this.parsedRows.slice(this.selectedRowIndex + 1, this.selectedRowIndex + 5);
            store_1.ordersStore.importedOrders = this.getImportedRowsObject();
            store_1.ordersStore.sampleFirst5DataRows = sampleDataRows;
            store_1.ordersStore.sampleFirstDataRow = sampleDataRows[0];
            this.orderColumnsHeader = store_1.ordersStore.importColumnsHeader.map(header => header.trim());
            if (this.rowSelected) {
                // Check to see if match known formats and inquire automation
                this.automateImport();
            }
        };
        this.checkMatchKnownFormats = (headers) => {
            const orderColumnsHeaderFiltered = this.orderColumnsHeader.filter((header) => {
                const omitHeaders = [
                    "PCN",
                    "BIN_NUM",
                    "BIN",
                    "BINNUM",
                    "PAYER_GROUP_ID",
                    "PAYERGROUPID",
                    "INSURANCE_ID",
                    "INSURANCEID"
                ];
                return !omitHeaders.includes(header.toUpperCase());
            });
            const headerSet = new Set(headers.map((header) => header.toLowerCase()));
            const importHeaderSet = new Set(orderColumnsHeaderFiltered.map((header) => header.toLowerCase()));
            const intersection = new Set([...headerSet].filter(x => importHeaderSet.has(x)));
            // console.log("headers", headers);
            // console.log("this.orderColumnsHeader", this.orderColumnsHeader);
            // console.log("headerSet", headerSet);
            // console.log("importHeaderSet", importHeaderSet);
            // console.log("intersection", intersection);
            if (intersection.size === orderColumnsHeaderFiltered.length) {
                // console.log(
                //   "--------------------------match found, size and length match header is",
                //   headers
                // );
                return true;
            }
            return false;
        };
        this.checkBillingPrecisionFormat = () => {
            if (this.orderColumnsHeader && this.orderColumnsHeader.length === 2) {
                const [firstColumn = "", secondColumn] = this.orderColumnsHeader;
                const re = /^\d{2}-[a-zA-Z]{3}$/;
                const matched = firstColumn.trim().match(re);
                if (matched && secondColumn === "__EMPTY") {
                    this.fileFormat = store_1.FileFormat.BillingPrecision;
                }
            }
        };
        this.automateImport = () => {
            const { knownHeaderFormats } = store_1.ordersStore;
            for (const format in knownHeaderFormats) {
                // SPECIAL CASE FOR BILLING PRECISION
                if (knownHeaderFormats.hasOwnProperty(format)) {
                    if (this.checkMatchKnownFormats(knownHeaderFormats[format])) {
                        switch (format) {
                            case "chiroTouch":
                                console.log("chirotouch match");
                                this.fileFormat = store_1.FileFormat.ChiroTouch;
                                break;
                            case "eclipse":
                                console.log("eclipse match");
                                this.fileFormat = store_1.FileFormat.Eclipse;
                                break;
                            case "vericle":
                                console.log("vericle match");
                                this.fileFormat = store_1.FileFormat.Vericle;
                                break;
                            case "nexgenHealthFusion":
                                console.log("nexgenhealthfusion match");
                                this.fileFormat = store_1.FileFormat.NexgenHealthFusion;
                                break;
                            case "advancedMD":
                                console.log("advancedMd match");
                                this.fileFormat = store_1.FileFormat.AdvancedMD;
                                break;
                            case "meditouch":
                                console.log("meditouch match");
                                this.fileFormat = store_1.FileFormat.Meditouch;
                                break;
                            case "practiceSuite":
                                console.log("practiceSuite match");
                                this.fileFormat = store_1.FileFormat.PracticeSuite;
                                break;
                            // case "billingVision":
                            //   this.fileFormat = FileFormat.BillingVision;
                            //   break;
                            case "medisoft":
                                console.log("medisoft match");
                                this.fileFormat = store_1.FileFormat.Medisoft;
                                break;
                            case "macPractice":
                                console.log("macpractice match");
                                this.fileFormat = store_1.FileFormat.MacPractice;
                                break;
                            default:
                                break;
                        }
                        if (this.fileFormat) {
                            break;
                        }
                    }
                }
            }
            if (!this.fileFormat) {
                this.checkBillingPrecisionFormat();
            }
            console.log("--------------------fileformat ----------", this.fileFormat);
            if (this.fileFormat) {
                this.inquireAutomation = true;
            }
            else {
                router_1.RouteManager.transitionTo("/claims/submit/map");
            }
        };
        this.handleInquiryResponse = (decision) => () => {
            if (decision === "yes") {
                store_1.ordersStore.fileFormat = this.fileFormat;
                store_1.ordersStore.shouldAutomateSubmission = true;
                router_1.RouteManager.transitionTo("/claims/submit/map");
            }
            else if (decision === "no") {
                store_1.ordersStore.fileFormat = this.fileFormat;
                router_1.RouteManager.transitionTo("/claims/submit/map");
            }
        };
        this.handleOnCancel = () => {
            // console.log('handleOnCancel triggered');
        };
        this.handleOnClickRow = (_e, i) => {
            const rowClicked = document.getElementById(`select-header-table__row--${i}`);
            const allRows = document.getElementsByClassName("select-header-table__row");
            [...allRows].forEach(row => row.classList.remove("active-row"));
            rowClicked.classList.add("active-row");
            this.selectedRowIndex = i;
            this.rowSelected = true;
        };
        this.renderTableRow = (row, i) => (React.createElement(core_1.TableRow, { className: `select-header-table__row`, id: `select-header-table__row--${i}`, onClick: e => this.handleOnClickRow(e, i), key: i }, row.map((cell, i) => (React.createElement(core_1.TableCell, { className: "select-header-table__row--cell", key: i }, cell)))));
        this.renderKPIElement = (element) => {
            let value;
            switch (element.color) {
                case "green":
                    value = "green";
                    break;
                case "red":
                    value = "red";
                    break;
                case "yellow":
                    value = "yellow";
                    break;
                default:
                    value = 0;
            }
            const elementMerged = ramda_1.merge(element, { value });
            return React.createElement(kpi_element_1.KpiElement, { element: elementMerged });
        };
    }
    componentWillUnmount() {
        this.inquireAutomation = false;
    }
    componentWillMount() {
        // console.log('cdm triggered');
        this.parsedRows = store_1.ordersStore.parsedRows[0]
            ? store_1.ordersStore.parsedRows[0].length
                ? store_1.ordersStore.parsedRows[0].filter((row) => !row.every((cell) => !cell))
                : []
            : [];
    }
    renderKPIElementGroup() {
        return (React.createElement(kpi_element_group_1.KpiElementGroup, { greenElement: greenElement, redElement: redElement, yellowElement: yellowElement, renderElement: this.renderKPIElement.bind(this) }));
    }
    render() {
        return (React.createElement("div", { className: "orders-submit-select" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: "Header Selection", subLabel: "" })),
            React.createElement(paper_1.MaterialPaper, { className: "orders-submit-select__header-select" },
                this.noHeaderRowSelectOnConfirm && (React.createElement("div", { className: "ui-alert--error" },
                    React.createElement(alert_1.UiAlert, { message: "Missing header row selection.", dismissable: true, onRequestDismiss: () => (this.noHeaderRowSelectOnConfirm = false) }))),
                React.createElement("div", { className: "header-paper__message" },
                    React.createElement("h3", null, "Please select a header row"),
                    React.createElement("div", null,
                        React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/claims" }, "Cancel"),
                        React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleOnConfirmation, 
                            // to={this.rowSelected ? "/claims/submit/map" : null}
                            disabled: !this.rowSelected }, "confirm"))),
                React.createElement("div", { className: "select-header-table-container" },
                    React.createElement(core_1.Table, { className: "select-header-table" },
                        React.createElement(core_1.TableBody, null, this.parsedRows // change to this.localTable for testing; this.parsedRows when done
                            .slice(0, 20)
                            .map((row, i) => this.renderTableRow(row, i)))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Make changes", message: `Please confirm you have mapped the correct headers.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: () => alert("confirmed"), title: "Confirm header mappings" })),
            this.inquireAutomation && (React.createElement(modal_1.Modal, { onCancel: () => (this.inquireAutomation = false) },
                React.createElement(core_1.Typography, { gutterBottom: true, variant: "headline", align: "center" }, "Auto Formating Detected"),
                React.createElement(core_1.Typography, null, "Would you like to automate this process?"),
                React.createElement("div", { className: "inquire-automation-buttons" },
                    React.createElement(button_1.MaterialButton, { className: "inquire-automation-buttons__button", flat: true, onClick: this.handleInquiryResponse("no") }, "No"),
                    React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleInquiryResponse("yes") }, "Yes"))))));
    }
};
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "parsedRows", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "parsedRowsTruncated", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "rowSelected", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "selectedRowIndex", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "noHeaderRowSelectOnConfirm", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "inquireAutomation", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "orderColumnsHeader", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitSelectHeader.prototype, "fileFormat", void 0);
OrdersSubmitSelectHeader = __decorate([
    mobx_react_1.observer
], OrdersSubmitSelectHeader);
exports.OrdersSubmitSelectHeader = OrdersSubmitSelectHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-submit-select-header/orders-submit-select-header.tsx
// module id = 3792
// module chunks = 0